"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileOperationErrorLog = void 0;
var zod_1 = require("zod");
var ErrorLogBase_1 = __importDefault(require("./ErrorLogBase"));
var ErrorLogType_1 = require("../ErrorLogType");
var ErrorLogLevel_1 = require("../ErrorLogLevel");
var ErrorLogSignInInfo_1 = require("../ErrorLogSignInInfo");
var ErrorLogAccessLevel_1 = require("../ErrorLogAccessLevel");
var FileOperationErrorLog;
(function (FileOperationErrorLog) {
    FileOperationErrorLog.AdditionalInformationSchema = zod_1.z.object({
        context: zod_1.z.string().optional().nullable(),
        errorMessage: zod_1.z.string().optional().nullable(),
        stackTrace: zod_1.z.string().optional().nullable(),
    });
    FileOperationErrorLog.Schema = ErrorLogBase_1.default.Schema.extend({
        type: zod_1.z.literal(ErrorLogType_1.ErrorLogType.Enum.fileOperationError),
        level: zod_1.z.literal(ErrorLogLevel_1.ErrorLogLevel.Enum.ERROR),
        signInInfo: ErrorLogSignInInfo_1.ErrorLogSignInInfo.Schema,
        additionalInformation: FileOperationErrorLog.AdditionalInformationSchema,
        accessLevel: zod_1.z.literal(ErrorLogAccessLevel_1.ErrorLogAccessLevel.Enum.ADMIN),
    });
})(FileOperationErrorLog || (FileOperationErrorLog = {}));
exports.FileOperationErrorLog = FileOperationErrorLog;
